import { type EventsHandler } from "./types"

const previewAllowedEvents: string[] = []

export const createEventsHandler = (): EventsHandler => {
    const events: Record<string, Record<number, Function>> = {}

    let nextHandle = 0
    const getNextHandle = () => ++nextHandle

    return {
        get: event => events[event as string],

        subscribe: (event, callback) => {
            // Skip in server-side rendering
            if (typeof window === "undefined") {
                return
            }

            const eventKey = event as string

            if (!events[eventKey]) {
                events[eventKey] = {}
            }

            const handle = getNextHandle()
            events[eventKey][handle] = callback

            return handle
        },

        trigger: (event, ...args) => {
            // Skip in server-side rendering
            if (typeof window === "undefined") {
                return
            }

            const eventKey = event as string

            if (events[eventKey] && Object.keys(events[eventKey]).length > 0) {
                Object.keys(events[eventKey]).forEach(handle => {
                    const callback = events[eventKey][parseInt(handle)]
                    if (typeof callback === "function") {
                        callback(...args)
                    }
                })
            } else {
                if (process.env.NEXT_PUBLIC_ENVIRONMENT === "development") {
                    console.warn(
                        `Event ${eventKey} is unknown or doesn't have any subscribers.`
                    )
                }
            }
        },

        unsubscribe: (event, handle) => {
            // Skip in server-side rendering
            if (typeof window === "undefined") {
                return
            }

            const eventKey = event as string

            if (events[eventKey] && events[eventKey][handle] !== undefined) {
                delete events[eventKey][handle]
                return true
            }

            return false
        }
    }
}

const Events = createEventsHandler()

export default Events
